// import { gql } from "../../../../__generated__";

// import { gql } from "@apollo/client"
import { gql } from "../../__generated__";

export const PEOPLE_PAGE_QUERY = gql(`
query PeoplePage($locationId:UUID,$query: String, $first: Int, $after: String){
  people(locationId:$locationId,query: $query, first: $first, after: $after){
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
    edges{
      cursor
      node{
        ...SelectedPerson_Person
      }
    }
    totalCount
  },
  location {
    totalStaff
    name
  }
}
`);

export const PERSON_STUDENTS_QUERY = gql(/* GraphQL */`
  query PersonStudents(
      $personId: UUID!
      $query: String
      $after: String
      $first: Int, 
  ) {
      person(id: $personId) {
          id
          students(query: $query, status: ACTIVE, first: $first, after: $after) {
              pageInfo {
                  startCursor
                  endCursor
                  hasPreviousPage
                  hasNextPage
              }
              edges {
                  ... _studentEdgePreview
              }
              totalCount
          }
      }
  }
`);

export const PERSON_STUDENT_EDGE_FRAGMENT = gql(/* GraphQL */`
  fragment _studentEdgePreview on StudentsEdge {
      cursor
      node {
          id
          firstName
          lastName
          dob
          references
          location{
              id
              name
          }
      }
  }
`);